import { axiosInstance } from './base'

export function fetchDashboardAnalytics () {
  return axiosInstance.get('dashboard/')
}

export function fetchActivePromotions () {
  return axiosInstance.get('active-promotions')
}

export function fetchCompanyDashboard (companyId) {
  return axiosInstance.get(`dashboard/${companyId}`)
}
